// `.env.ts` is generated by the `npm run env` command
import env from './.env';

export const environment = {
  production: false,
  // version: env.npm_package_version,
  defaultLanguage: 'en-US',
  supportedLanguages: [
    'th-TH',
    'en-US'
  ],
  version: '1.0.0',
  //apiPort: "444/ApiGateway/customApi", /ApiGateway/customApi
  apiPort: "443",
  apiPath: "/ApiGateway/customApi",
  apiurl:"",
  AcceptUploadFileExtension: ".jpg, .jpeg, .png, .pdf",
  apiProtocol: "https:",
  MaxFileSize: 10,
  keySize: 128,
  timeoutIdleMinute: 60,
  SOCKET_ENDPOINT: 'http://localhost:3000/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts